/* eslint-disable react/destructuring-assignment */

import React from 'react';
import { WrappedFieldArrayProps } from 'redux-form';

import Preloader from '@omilia/preloader';

import CreateNewUtterance from './components/CreateNewUtterance';

// @ts-ignore
import UtterancesList from './components/UtterancesList';

type Utterance = {
  id: string;
  utterance: string;
  intent?: string;
};

type Props = WrappedFieldArrayProps<Utterance> & { isLoading: boolean };

const MachineLearning = ({ fields, isLoading }: Props) => {
  const { push, remove, getAll } = fields;

  const utterances = getAll();

  return (
    <React.Fragment>
      {isLoading && <Preloader showBackdrop data-test="preloader" />}

      <CreateNewUtterance onAddUtterance={push} />

      {utterances.length > 0 && (
        <UtterancesList utterances={utterances} onDelete={remove} />
      )}
    </React.Fragment>
  );
};

export default MachineLearning;
